import { DemoButton } from '@web/components/DemoButton'
import { MarketingCTA } from '@web/sections/CTA/MarketingCTA'
import { Link } from 'react-router-dom'

const ClosingCTA = () => {
  return (
    <section className="bg-neutral-muted pt-16 pb-10 sm:pt-8 sm:pb-8">
      <MarketingCTA>
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 lg:items-start">
          <h2 className="text-center font-extralight leading-tight tracking-tight text-text-inverted lg:text-left lg:leading-tight text-5xl m-0">
            See it on your council&rsquo;s data.
          </h2>
          <p className="text-center lg:text-left text-lg text-text-inverted/85 max-w-3xl m-0">
            A 20-minute walkthrough using your district&rsquo;s hazards, not a generic demo. No
            slide deck, no follow-up sales call unless you ask for one.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <DemoButton theme="light" label="Book a 20-minute walkthrough" />
            <Link
              to="/contact"
              className="px-8 py-3 text-sm font-semibold no-underline transition-colors rounded border border-solid border-white/60 text-text-inverted bg-transparent hover:bg-white/10 whitespace-nowrap"
            >
              Contact us
            </Link>
          </div>
        </div>
      </MarketingCTA>
      <p className="mx-auto max-w-5xl px-6 lg:px-8 pt-8 text-xs text-brand-navy/60 leading-relaxed m-0">
        Property is a module of Resilience Explorer®, built by Urban Intelligence Ltd, Ōtautahi
        Christchurch. ISO 27001 aligned. No data sharing with third parties without explicit client
        consent.
      </p>
    </section>
  )
}

export default ClosingCTA
